import React from 'react';
import PropTypes from 'prop-types';
import Button from 'components/buttons/Button';
import ArrowBack from '@material-ui/icons/ArrowBack';

const SequenceBuilderActions = ({
  onBack,
  onSkip,
  onSave,
  onNext,
  onDelete,
  disabledSave,
  disabledNext,
  saveBtnText,
  nextBtnText,
  isLoading,
}) => (
  <>
    <hr className="instance-form__divider" />
    <div className="instance-form__builder-footer">

      {onBack ?
        <Button
          type="button"
          color="secondary"
          variant="text"
          onClick={onBack}
          startIcon={<ArrowBack />}
        >
          Back
        </Button> : <div />
      }
      <div>
        {onSkip &&
          <Button
            type="button"
            color="secondary"
            variant="text"
            onClick={onSkip}
          >
            Skip
          </Button>
        }
        {onDelete &&
          <Button
            type="button"
            color="delete"
            variant="outlined"
            onClick={onDelete}
          >
            Delete Sequence
          </Button>
        }
        {onSave &&
          <Button
            type="button"
            color="secondary"
            variant="textPrimaryContained"
            onClick={onSave}
            disabled={disabledSave || isLoading}
            className="ml-2"
          >
            {saveBtnText}
          </Button>
        }
        <Button
          color="primary"
          variant="contained"
          className="ml-2"
          disabled={disabledNext || isLoading}
          onClick={onNext}
        >
          {nextBtnText}
        </Button>
      </div>
    </div>
  </>
);

SequenceBuilderActions.propTypes = {
  onBack: PropTypes.func.isRequired,
  onSave: PropTypes.func.isRequired,
  onNext: PropTypes.func.isRequired,
  onDelete: PropTypes.func,
  onSkip: PropTypes.func,
  saveBtnText: PropTypes.string,
  nextBtnText: PropTypes.string,
  isLoading: PropTypes.bool,
};

SequenceBuilderActions.defaultProps = {
  saveBtnText: 'Save',
  nextBtnText: 'Next',
  onDelete: null,
  onSkip: null,
  isLoading: false,
};

export default SequenceBuilderActions;
